import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class StepService {

  private readonly STORAGE_KEY = 'auth_flow_step';

  private stepSubject = new BehaviorSubject<number>(
    this.getStoredStep()
  );

  step$ = this.stepSubject.asObservable();

  setStep(value: number) {
    this.stepSubject.next(value);
    localStorage.setItem(this.STORAGE_KEY, value.toString());
  }

  get currentStep(): number {
    return this.stepSubject.value;
  }

  private getStoredStep(): number {
    return parseInt(localStorage.getItem(this.STORAGE_KEY) || '0', 10);
  }

  reset() {
    this.stepSubject.next(0);
    localStorage.removeItem(this.STORAGE_KEY);
  }
}